import React from 'react';
import {
  IconTwitter,
  IconInstagram,
  ButtonSecondary,
} from '@spotify-internal/encore-web-v6';
import { TRACK_CAT } from '../constants';
import { useTracking } from '../../../Tracking/index';
import styled from 'styled-components';

const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
`;

export const Social = () => {
  const { eventHandler } = useTracking();
  return (
    <SocialContainer>
      <ButtonSecondary
        href="https://twitter.com/spotifyartists"
        target="_blank"
        data-testid="footer-twitter"
        iconOnly={IconTwitter}
        aria-label="Twitter"
        onClick={eventHandler(`Frodor - ${TRACK_CAT}`, 'Social - Twitter')}
      />
      <ButtonSecondary
        data-testid="footer-instagram"
        target="_blank"
        href="https://www.instagram.com/spotifyforartists/"
        iconOnly={IconInstagram}
        aria-label="Instagram"
        onClick={eventHandler(`Frodor - ${TRACK_CAT}`, 'Social - Instagram')}
      />
    </SocialContainer>
  );
};
